import { Component, OnInit } from '@angular/core';
import { SuperadminService } from 'src/app/services/superadmin/superadmin.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LookupService } from 'src/app/services/Common/lookup.service';

@Component({
  selector: 'app-superpagesetup',
  templateUrl: './superpagesetup.component.html',
  styleUrls: ['./superpagesetup.component.css']
})
export class SuperPageSetUpComponent implements OnInit {

  UserTypeList: any;
  Parent: any;
  alertMessage: any;

  Submitted: boolean = false;
  PageSetUpList: any;
  dropdownSettings: any = {};
  selectedItems: any = [];

  constructor(private superadminservice: SuperadminService, private lookupservice: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }


    SearchModel={
      SiteMapTypeID:0,
      UserPanelID:0,
      ParentID: 0,
      Title: '',
      Url: '',
    }

    ClearSearch(){
      this.SearchModel.UserPanelID=0;
      this.SearchModel.SiteMapTypeID=0;
      this.SearchModel.ParentID=0;
      this.SearchModel.Title='';
      this.SearchModel.Url='';
      this.PageSetUpList=[];
    }

    GetAllPageSetUp() {
      this.spinnerService.show();
      this.superadminservice.GetAllPageSetUp(JSON.stringify(this.SearchModel)).subscribe((response: any) => {
        this.PageSetUpList = response.PageSetUpList;
        this.spinnerService.hide();
  
      });
    };

  PageSetupModel = {
    SiteMapID: 0,
    ParentID: 0,
    SequenceNo: '',
    Description: '',
    Title: '',
    Url: '',
    UserTypeIDs: '',
    IsActive: true,
    SiteMapTypeID:0,
    UserPanelID:0,
    UserTypeArray: [],
  };

  CleanPageSetup() {

    this.PageSetupModel.SiteMapID = 0;
    this.PageSetupModel.SiteMapTypeID = 0;
    this.PageSetupModel.UserPanelID=0;
    this.PageSetupModel.ParentID = 0;
    this.PageSetupModel.SequenceNo = '';
    this.PageSetupModel.Description = '';
    this.PageSetupModel.Title = '';
    this.PageSetupModel.Url = '';
    this.PageSetupModel.UserTypeIDs = '';
    this.PageSetupModel.IsActive = false;
    this.PageSetupModel.UserTypeArray = [];
    this.Submitted = false;


  };


  

  
  ValidationPageSetUpDropdown() {

    for (var i = 0; i < this.PageSetUpList.length; i++) {
      if (this.PageSetUpList[i].Url == this.PageSetupModel.Url && this.PageSetupModel.SiteMapID != this.PageSetUpList[i].SiteMapID && this.PageSetUpList[i].Url != '') {
        this.alertMessage = 'Url already exist';
        return true;
      }

    }
  }
  SavePageSetUp(valid) {

    var UserTypeID = '';

    for (var i = 0; i < this.UserTypeList.length; i++) {
      for (var j = 0; j < this.PageSetupModel.UserTypeArray.length; j++) {
        if (this.PageSetupModel.UserTypeArray[j].ItemId == this.UserTypeList[i].ItemId && UserTypeID == '') {
          UserTypeID = this.UserTypeList[i].ItemId;
        }
        else if (this.PageSetupModel.UserTypeArray[j].ItemId == this.UserTypeList[i].ItemId) {
          UserTypeID = UserTypeID + "," + this.UserTypeList[i].ItemId;
        }
      }
    }
    this.PageSetupModel.UserTypeIDs = UserTypeID;
  
    if (this.PageSetupModel.SequenceNo == '')
      this.PageSetupModel.SequenceNo = '0';
    this.Submitted = true;
    if (valid && this.PageSetupModel.UserPanelID!=0 && this.PageSetupModel.UserTypeIDs != '') {
      this.spinnerService.show();
      this.superadminservice.SavePageSetUp(JSON.stringify(this.PageSetupModel)).subscribe((response: any) => {
        this.GetAllPageSetUp();
        this.alertMessage = '';
        this.CleanPageSetup();
        this.spinnerService.hide();
        this.globalHelper.CheckActionStatus(response)
        this.BindParent();
      });
    }
  };



  EditPageSetUp(item) {

    this.selectedItems = [];
    this.PageSetupModel.SiteMapID = item.SiteMapID;
    var UserTypeIDs = item.UserTypeIDs != null ? item.UserTypeIDs.split(',') : '';
    for (var i = 0; i < this.UserTypeList.length; i++) {
      for (var j = 0; j < UserTypeIDs.length; j++) {
        if (UserTypeIDs[j] == this.UserTypeList[i].ItemId) {
          let item = {
            ItemId: this.UserTypeList[i].ItemId,
            ItemName: this.UserTypeList[i].ItemName

          }
          this.selectedItems.push(item)
          break;
        }
      }
    }


    this.PageSetupModel.UserTypeArray = this.selectedItems;
    this.PageSetupModel.ParentID = item.ParentID;
    this.PageSetupModel.Description = item.Description;
    this.PageSetupModel.Url = item.Url;
    this.PageSetupModel.SiteMapTypeID = item.SiteMapTypeID;
    this.PageSetupModel.Title = item.Title;
    this.PageSetupModel.SequenceNo = item.SequenceNo;
    this.PageSetupModel.IsActive = item.IsActive;
    this.PageSetupModel.UserPanelID=item.UserPanelID;

  };


  SiteMapMarkActive(obj) {
    this.CleanPageSetup();
    this.PageSetupModel.SiteMapID = obj.SiteMapID;
    this.PageSetupModel.IsActive = obj.IsActive == true ? false : true;
    this.spinnerService.show();
    if (this.PageSetupModel.SequenceNo == '')
      this.PageSetupModel.SequenceNo = '0';

    this.superadminservice.SiteMapMarkActive(JSON.stringify(this.PageSetupModel)).subscribe((response: any) => {
      this.spinnerService.hide();
      this.GetAllPageSetUp();
      this.globalHelper.CheckActionStatus(response);

    });
  }


  ngOnInit() {
    this.BindSiteMapType();
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'ItemId',
      textField: 'ItemName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: false
    };

    this.BindParent();
    this.BindUserType();
    this.BindUserPanel();
    // this.GetAllPageSetUp();



  }



  BindUserType() {
    this.lookupservice.GetLookupsList('UserType', '').subscribe((data: any) => {
      this.UserTypeList = data.LookupItems;
      this.UserTypeList.splice(0, 1)
    });
  };
  UserPanelList=[];
  BindUserPanel() {
    this.lookupservice.GetLookupsList('UserPanel', '').subscribe((data: any) => {
      this.UserPanelList = data.LookupItems;
     
    });
  };
  SiteMapTypeList:any;
  BindSiteMapType() {
    this.lookupservice.GetLookupsList('SiteMapType', '').subscribe((data: any) => {
      this.SiteMapTypeList = data.LookupItems;
      // this.UserTypeList.splice(0, 1)
    });
  };
  BindParent() {
    this.lookupservice.GetLookupsList('ParentSiteMap', '').subscribe((data: any) => {
      this.Parent = data.LookupItems;
    });
  };

}


